
import Vue from 'vue'
import { newSearch } from '../store/actions';
import { IFilter } from '../store/state';

interface FilterData {
    selected: string | null,
}

interface FilterMethods {

}

interface FilterComputed {
    selected: string,
    uppCaseType: string,
}

interface FilterProps {
    filter: IFilter
}


export default Vue.extend<FilterData, FilterMethods, FilterComputed, FilterProps>({
	name: 'FilterComponent',
    props: {
        filter: {
            type: Object,
            required: true,
        }
    },
	computed: {
        uppCaseType() {
            return this.filter.type[0].toUpperCase() + this.filter.type.slice(1);
        },
        selected: {
            get() {
                return this.$store.state['selected' + this.uppCaseType];
            },
            set(newVal) {
                this.$store.commit({
                    type: 'setSelected' + this.uppCaseType,
                    payload: newVal
                })
                this.$store.commit({
                    type: 'setPage',
                    payload: 1,
                })
                this.$store.dispatch(newSearch(null));
            }
        }
    }
})
